import { parse } from 'date-fns'
import { LocalDate } from '@js-joda/core'
import NativeDateConverter from '@migrate/utils/date/NativeDateConverter'
import { ILM_DATE_FORMAT } from '@migrate/utils/date/constants'
import LocalDateConverter from '@migrate/utils/date/LocalDateConverter'
import i18next from 'i18next'

export default class IlmFormatStringConverter {
  private readonly value: string

  constructor(value: string) {
    this.value = value
  }

  public toNativeDate(): Date {
    return parse(this.value, ILM_DATE_FORMAT, new Date())
  }

  public toLocalDate(): LocalDate {
    return new NativeDateConverter(this.toNativeDate()).toLocalDate()
  }

  public toLocalizedDateString(locale: string | string[] = i18next.language): string {
    return new LocalDateConverter(this.toLocalDate()).toLocalizedString(locale)
  }
}
